import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { FeedContext } from '../FeedContext';
import config from '../config';
import { isEnterKey, isEscapeKey } from '../utils/helpers';

function MultiSelect({ name, title, options, selected }) {
  const context = useContext(FeedContext);
  const [open, setOpen] = useState(false);
  const label = buildLabel(options, selected);
  const optionElements = options.map((item) => {
    return (
      <Option
        key={item}
        id={item}
        name={item}
        selected={selected.includes(item)}
        clickHandler={(id) => context.toggleFilter(name, id)}
      />
    );
  });

  const toggleOptions = () => {
    setOpen((open) => !open);
  };

  const closeOptions = () => {
    setOpen(false);
  };

  const clearFilter = () => {
    context.clearFilter(name);
  };

  const componentClass = classNames({
    'c-multiselect': true,
    'is-open': open,
  });

  return (
    <div className={componentClass}>
      <div
        tabIndex="0"
        role="button"
        aria-label={config.text.selectFiltersAriaLabel + ' ' + title}
        aria-expanded={open}
        className="c-multiselect__button"
        onKeyPress={(e) => isEnterKey(e, toggleOptions)}
        onKeyDown={(e) => isEscapeKey(e, closeOptions)}>
        <div className="c-multiselect__title" onClick={toggleOptions}>
          {title}
        </div>
        <div className="c-multiselect__field" onClick={toggleOptions}>
          {label}
        </div>
      </div>
      <ul className="c-multiselect__options">
        {optionElements}
        <div
          tabIndex={label !== config.text.selectAll ? 0 : -1}
          className="c-multiselect__clear"
          aria-label={config.text.selectClearA11y}
          onClick={clearFilter}
          onKeyPress={(e) => isEnterKey(e, clearFilter)}>
          {config.text.selectClear}
        </div>
      </ul>
    </div>
  );
}

const buildLabel = (options, selected) => {
  if (!selected.length) return config.text.selectAll;

  // find the names of the selected options
  const names = selected
    .map((id) => {
      const match = options.find((option) => {
        return option.id === id;
      });

      return match && match.name ? match.name : false;
    })
    .filter((name) => {
      return name;
    });

  return names.length ? names.join(', ') : config.text.selectAll;
};

function Option({ id, name, selected, clickHandler }) {
  const handleClick = () => {
    clickHandler(id);
  };

  const handleKeyPress = (e) => {
    e.stopPropagation();

    isEnterKey(e, handleClick);
  };

  const componentClass = classNames({
    'c-multiselect__option': true,
    'c-multiselect__option--selected': selected,
  });

  return (
    <li
      tabIndex="0"
      role="checkbox"
      aria-checked={selected}
      className={componentClass}
      onClick={handleClick}
      onKeyPress={handleKeyPress}>
      {name}
    </li>
  );
}

export default MultiSelect;
